/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';
import { Loader, Table } from '../../../Components/uielements';
import TimesheetService from '../../../services/bioplus-services/timesheet';
import { IntlMessages } from '../../../helper/langHelper';
import moment from 'moment';
import { convertToUserTimeZone } from '../../../helper/dataFormat';

const VisitorAttendance = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const query = useQuery(['timesheetEntries'], () => TimesheetService.listTimesheet());

  const userTableData = query?.data?.timesheets || [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName ?? '--'} ${
              cellData?.row?.original?.userId?.lastName ?? '--'
            }`}
          </TableCell>
        ),
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.geofence.name" />,
        accessor: 'geofence',
        Cell: (cellData) => (
          <TableCell>{`${cellData?.row?.original?.geofenceId?.name ?? '--'}`}</TableCell>
        ),
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.date" />,
        accessor: 'recordDate',
        width: '16%',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.checkIn" />,
        accessor: 'checkin',
        width: '15%',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? convertToUserTimeZone(cellData.value, userTimeZone) : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.checkOut" />,
        accessor: 'checkout',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? convertToUserTimeZone(cellData.value, userTimeZone) : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.createdAt" />,
        accessor: 'createdAt',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
    ],
    [userTimeZone]
  );

  if (query.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.attendance" />
        </HeaderTitle>
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={userTableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={query?.data?.timesheets?.length || 0}
        />
      </TableWrapper>
    </StyledContainer>
  );
};

export default VisitorAttendance;
